import {
  CONTACT_STATUSES,
  isValidContactStatus,
} from "./contactStatuses";

const STORAGE_KEY = "bizmak_mgmt_contact_submissions";

function readRaw() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeAll(items) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

function normalizeSubmission(row) {
  const status = isValidContactStatus(row.status) ? row.status : "new";
  return {
    id: String(row.id),
    fullname: row.fullname ?? "",
    emailAddress: row.emailAddress ?? "",
    phoneNumber: row.phoneNumber ?? "",
    message: row.message ?? "",
    status,
    createdAt: row.createdAt ?? new Date().toISOString(),
    updatedAt: row.updatedAt ?? row.createdAt ?? new Date().toISOString(),
  };
}

export function listContactSubmissions() {
  return readRaw().map(normalizeSubmission);
}

export function addContactSubmissionFromPublicForm(payload) {
  const now = new Date().toISOString();
  const row = normalizeSubmission({
    id:
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `c_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`,
    fullname: payload.fullname,
    emailAddress: payload.emailAddress,
    phoneNumber: payload.phoneNumber,
    message: payload.message,
    status: "new",
    createdAt: now,
    updatedAt: now,
  });
  const all = readRaw();
  all.unshift(row);
  writeAll(all);
  return row;
}

export function updateContactSubmissionStatus(id, status) {
  if (!isValidContactStatus(status)) return null;
  const all = readRaw();
  const idx = all.findIndex((r) => String(r.id) === String(id));
  if (idx === -1) return null;
  const now = new Date().toISOString();
  const updated = {
    ...normalizeSubmission(all[idx]),
    status,
    updatedAt: now,
  };
  all[idx] = updated;
  writeAll(all);
  return updated;
}

export function countByStatus(submissions) {
  const counts = Object.fromEntries(CONTACT_STATUSES.map((s) => [s, 0]));
  for (const s of submissions) {
    if (counts[s.status] !== undefined) counts[s.status] += 1;
  }
  return counts;
}
